import { post } from "@utils/httpUtil";

export function catalogDelete(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post("/baseQuestionnaire/catalog/delete", data, config);
}

export function deleteCatalogAndRelation(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post("/baseQuestionnaire/catalog/deleteCatalogAndRelation", data, config);
}

export function getById(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post("/baseQuestionnaire/catalog/getById", data, config);
}

export function getCreateList(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post("/baseQuestionnaire/catalog/getCreateList", data, config);
}

export function getList(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post("/baseQuestionnaire/catalog/getList", data, config);
}

export function getPageInfo(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post("/baseQuestionnaire/catalog/getPageInfo", data, config);
}

export function insertOrUpdate(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post("/baseQuestionnaire/catalog/insertOrUpdate", data, config);
}

export function update(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post("/baseQuestionnaire/catalog/update", data, config);
}
